<template>
  <div>
    <es-loader v-if="loading" style="margin: 6.5rem"/>
    <es-exception v-if="!loading && loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-if="!loading && !loadingError">
      <es-profile-header>
        <template #profile-header>
          <div class="columns">
            <div class="column">
              <div class="column-content">
                <div class="header-title">
                  {{locationMaster.name}}
                </div>
                <div class="header-subtitle">
                  {{ locationMaster.street1 ? `${locationMaster.street1}, ` : '' }}
                  {{ locationMaster.street2 ? `${locationMaster.street2}, ` : '' }}

                </div>
                <div class="header-subtitle">
                  {{ locationMaster.city ? `${locationMaster.city}, ` : '' }}
                  {{ locationMaster.stateCode ? `${locationMaster.stateCode}, ` : '' }}
                  {{ locationMaster.zip ? `${maskZip(locationMaster.zip)}` : '' }}
                </div>
              </div>
            </div>
            <div class="column is-flex flex-justify--center flex-align--center">
              <div class="column-content">
                <div class="header-subtitle is-flex flex-align--center">
                  <font-awesome-icon :icon="['fas', 'envelope']" size="1x"/>
                  <span v-if="locationMaster.adminEmail" class="padding--left">
                    {{locationMaster.adminEmail}}
                  </span>
                  <span v-else class="padding--left">N/A</span>
                </div>
                <div class="header-subtitle">
                  <font-awesome-icon :icon="['fas', 'phone']" size="1x"/>
                  <span v-if="locationMaster.adminPhone" class="padding--left">
                    {{locationMaster.adminPhone}}
                  </span>
                  <span v-else class="padding--left">N/A</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #profile-overview>
          <div class="columns">
            <div class="column">
              <div class="column-content">
                <div class="column-title">{{ status(locationMaster.active) }}</div>
                <div class="column-subtitle">Status</div>
              </div>
            </div>
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{locationMaster.startDate | formatDateMMDDYYYY }}
                </div>
                <div class="column-subtitle">Start Date</div>
              </div>
            </div>
            <div class="column">
              <div class="column-content">
                <div class="column-title">
                  {{locationMaster.endDate | formatDateMMDDYYYY }}
                </div>
                <div class="column-subtitle">End Date</div>
              </div>
            </div>
          </div>
        </template>
      </es-profile-header>
      <div class="tabs-container">
        <div class="tabs no-bottom-border">
          <ul>
            <li :class="{ 'is-active': this.$route.name === 'locationDetails' }">
              <router-link
                :to="{
                  name: 'locationDetails',
                }"
              >
                DETAILS
              </router-link>
            </li>
            <li :class="{ 'is-active': this.$route.name === 'locationHistory' }">
              <router-link
                :to="{
                  name: 'locationHistory',
                }"
              >
                HISTORY
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <router-view @updated="refresh"/>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEnvelope,
  faPhone,
} from '@fortawesome/pro-solid-svg-icons';
import moment from 'moment';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import NotificationManager from '@/mixins/NotificationManager';
import ZipUtils from '@/mixins/ZipUtils';

library.add(
  faEnvelope,
  faPhone,
);

export default {
  mixins: [BreadcrumbsManager, NotificationManager, ZipUtils],
  components: {
    EsException,
    EsLoader,
    EsProfileHeader,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      apiMsg: '',
      locationMaster: '',
      isActive: false,
      location: null,
      loading: null,
      loadingError: null,
    };
  },
  created() {
    this.onLoad();
  },
  computed: {
    editlist() {
      return this.lists.filter(l => l.value !== this.locationMaster.active);
    },
  },
  methods: {
    ...mapActions([
      'getLocation',
    ]),
    async onLoad() {
      this.loading = true;
      this.loadingError = false;
      try {
        const response = await this.getLocation(this.id);
        this.initialize(response.data);
        this.setBreadcrumbs();
      } catch (error) {
        this.loadingError = true;
        this.apiMsg = `${error.response.status === 500 ? 'Network Error' : error.response.data.message}`;
        this.showNotification('danger', [this.apiMsg]);
      }
      this.loading = false;
    },
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'groupList' } },
        { text: 'Location Profile', to: {} },
        { text: ':locationName', to: {} },
      ]);

      this.replaceBreadcrumb({
        find: ':locationName',
        replace: { text: `${this.locationMaster.name}`, to: {} },
      });
    },
    initialize(data) {
      this.locationMaster = this.setDefaults(data);
    },
    setDefaults(location) {
      const l = location;
      return l;
    },
    refresh() {
      this.onLoad();
    },
    toggleIsActive() {
      this.isActive = !this.isActive;
    },
    status(flag) {
      return flag ? 'Active' : 'Inactive';
    },
  },
};
</script>

<style lang="sass" scoped>
  .edit-link
    color: #5953A4
    text-decoration: none
    background-color: transparent
    font-size: .75rem
    font-weight: 400
  .inactive-link
    text-decoration: none
    disabled: true
    &:hover
      cursor: default
      text-decoration: none
  .padding--left
    padding-left: 1rem
</style>
